import { useRef, useState } from 'react';
import cn from 'classnames';
import map from 'lodash/map';
import size from 'lodash/size';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import styles from './Accordion.module.scss';
import { useGSAP } from '@gsap/react';
import gsapInstance from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsapInstance.registerPlugin(ScrollTrigger);

export const Accordion = (props) => {
  const { items } = props;
  const breakpoint = useBreakpoint();
  const containerRef = useRef(null);
  const imageDesktopRef = useRef(null);
  const imageDesktopStickyRef = useRef(null);
  const itemsRef = useRef([]);
  const itemsImageRef = useRef([]);
  const [ activeHover, setActiveHover ] = useState(false);
  const [ itemHover, setItemHover ] = useState(false);
  
  const showImages = () => {
    console.info('show')
    gsapInstance.to(imageDesktopRef.current, { autoAlpha: 1, duration: .2 });
  }

  const hideImages = () => {
    console.info('hide')
    gsapInstance.to(imageDesktopRef.current, { autoAlpha: 0, duration: .2 });
  }

  useGSAP(() => {
    if(breakpoint === 'desktop' && imageDesktopRef.current) {
      const indexLast = size(items) - 1;
      const imageDesktopHeight = imageDesktopRef.current.clientHeight / 2;

      imageDesktopStickyRef.current = ScrollTrigger.create({
        trigger: imageDesktopRef.current,
        start: `top center-=${ imageDesktopHeight }`,
        end: `bottom center+=${ imageDesktopHeight }`,
        endTrigger: containerRef.current,
        pinnedContainer: containerRef.current,
        pin: true,
        scrub: true,
        refreshPriority: 1,
      })

      map(itemsRef.current, (item, index) => {
        ScrollTrigger.create({
          trigger: item,
          start: 'top center',
          end: 'bottom center',
          scrub: true,
          onToggle: ({ isActive }) => {
            setItemHover(isActive ? index : false)

            gsapInstance.to(itemsImageRef.current[index], { autoAlpha: isActive ? 1 : 0 });
          },
          onEnter: () => {
            if(index === 0) showImages()
          },
          onLeaveBack: () => {
            if(index === 0) hideImages()
          },
          onLeave: () => {
            if(index === indexLast) hideImages()
          },
          onEnterBack: () => {
            if(index === indexLast) showImages()
          }
        })
      })
    }

    return () => {
      imageDesktopStickyRef.current?.kill();
    }
  }, [ breakpoint ])

  return (
    <div className={ styles.container } ref={ containerRef }>
      <ol className={ styles.list }>
        { map(items, (item, index) => (
          <li
            key={ index }
            className={ cn(
              styles.item, 
              {
                [styles.hover]: itemHover === index
              }
            ) }
            ref={ el => itemsRef.current[index] = el }
          >
            <div className={ styles.inner }>
              <div
                className={ styles.title }
                dangerouslySetInnerHTML={ { __html: item.title } }
              />
            </div>
            {breakpoint === 'mobile' &&
              <div className={ styles.imageMobile }>
                <img src={ item.img } alt="" />
              </div>
            }
          </li>
        )) }
      </ol>
      <div className={ styles.imageDesktop } ref={ imageDesktopRef }>
        { map(items, (item, index) => (
          <img key={ index } src={ item.img } alt="" ref={ el => itemsImageRef.current[index] = el } />
        )) }
      </div>
    </div>
  )
}
